import { Divider } from '@/components/ui/divider'
import { Rating } from '@/components/ui/rating'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { formatNumber } from '@/lib/utils'
import { ERankingType } from '@/types/auth'
import { TReviewCoolClub } from '@/types/club'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { RANKING_IMAGES } from '../constants'

export const ReviewItem = ({ review }: { review: TReviewCoolClub }) => {
  const t = useTranslations()
  const imageUrl = ImageHelper.getImageUrl(
    t(
      RANKING_IMAGES[
        review.rank_title === 'golden'
          ? 'gold'
          : (review.rank_title as ERankingType)
      ] || RANKING_IMAGES[ERankingType.NEW]
    )
  )

  return (
    <div className='h-full w-full lg:rounded-lg lg:bg-light lg:p-4 lg:shadow-md'>
      <h3 className='mb-1 font-criteria text-base font-semibold text-neutral-900'>
        {review.name}
      </h3>

      <div className='flex items-center gap-1'>
        <Image
          src={imageUrl}
          alt={t('landing_coolclub_page.reviews.item.rank_alt')}
          width={100}
          height={24}
          className='h-6 w-auto object-cover'
        />
        <Divider
          className='mx-1 h-3 bg-neutral-800/20 lg:h-5'
          type='vertical'
        />
        <Image
          src={ImageHelper.getImageUrl('/image/November2024/mceclip3_91.jpg')}
          alt={t('landing_coolclub_page.reviews.item.coolcash_alt')}
          width={18}
          height={18}
        />
        <span className='text-sm text-neutral-600'>
          {t('landing_coolclub_page.reviews.item.coolcash_text', {
            amount: formatNumber(Number(review.coolcash)),
          })}
        </span>
      </div>
      <Rating value={4} readOnly className='my-4' size='sm' />

      <p
        className='font-sans text-base leading-5 text-neutral-700'
        dangerouslySetInnerHTML={{ __html: review.review }}
      />
    </div>
  )
}
